import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import DropDown from './DropDown'
import MultiInput from './MultiInput'
import { withApi } from '~shared/api/ApiContext'
import NumberField from '~shared/components/NumberField'
import CustomMultipleMenu from '~components/atom/FieldFactory/CustomMultipleMenu'
import CustomMenuField from '~components/atom/FieldFactory/CustomMenuField'
import TrueFalseSwitch from './TrueFalseSwitch'
import ConditionsBlocks from '~components/atom/FieldFactory/ConditionsBlocks'

const styles = () => ({
  root: {},
  nestedRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  select: {
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: 34,
  },
  condition: {
    width: '100%',
    margin: 0,
    borderRadius: 5,
    border: '1px solid rgba(0,0,0,0.1)',
  },
  nestedCondition: {
    padding: 10,
    margin: 10,
    boxSizing: 'border-box',
  },
  and: {
    margin: `4px 0`,
  },
  addButton: {
    marginTop: 5,
    flexGrow: 0,
    alignSelf: 'flex-start',
  },
})

class SegmentationQuery extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  async componentDidMount() {
    const { api } = this.props

    let { request } = api.getSegmentationOptions()

    let options
    let groupedOptions
    try {
      options = await request

      const clusters = []
      groupedOptions = options.reduce((accu, opt) => {
        if (!clusters.includes(opt.cluster)) {
          clusters.push(opt.cluster)
          accu.push({ value: opt.cluster, label: opt.cluster, disabled: true, isClusterName: true })
        }
        accu.push(opt.field)
        return accu
      }, [])
    } catch (err) {
      return
    }

    this.setState({ options, groupedOptions })
  }

  _getConditionByIndex = index => {
    const { value: query } = this.props
    return query[index]
  }

  _updateCondition = (index, data) => {
    const { value: query } = this.props

    let condition = this._getConditionByIndex(index)

    const newQuery = [...query]
    condition = { ...condition, ...data }
    newQuery[index] = condition

    const { onChange } = this.props

    onChange({
      target: {
        value: newQuery,
        name: this.props.name,
      },
    })
  }

  handleFieldChange = index => e => {
    const { options } = this.state
    const condition = this._getConditionByIndex(index)
    const { value } = e.target

    let data = {
      field: value,
      value: null,
    }

    const option = options.find(o => o.field === value)
    const { operators = [] } = option

    const { operator } = condition
    if (!operators.includes(operator)) data.operator = operators[0] ? operators[0].value : null

    this._updateCondition(index, data)
  }

  handleOperatorChange = index => e => {
    const { value } = e.target
    this._updateCondition(index, { operator: value })
  }

  handleValueChange = index => e => {
    const { value } = e.target

    this._updateCondition(index, { value })
  }

  handleRemoveCondition = index => () => {
    const { value: query, onChange } = this.props

    const newQuery = [...query]
    newQuery.splice(index, 1)

    onChange({
      target: {
        value: newQuery,
        name: this.props.name,
      },
    })
  }

  renderValueInput = (item, options, index, disabled) => {
    const { classes } = this.props
    const { value = [] } = item
    const { type, values } = options

    let props = {
      value,
      disabled,
      onChange: this.handleValueChange(index),
    }

    switch (type) {
      case 'date':
        return <CustomMenuField {...props} style={{ minHeight: 34 }} options={values} />
      case 'text':
        return <MultiInput {...props} />
      case 'enum':
      case 'multiple':
        return (
          <CustomMultipleMenu {...props} classes={{ select: classes.select }} options={values} />
        )
      case 'boolean':
        return <TrueFalseSwitch {...props} />
      case 'integer':
      case 'float':
      case 'array':
        return (
          <NumberField
            {...props}
            inputProps={{
              step: type === 'integer' ? 1.0 : undefined,
            }}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            InputProps={{
              style: { minHeight: 34 },
            }}
            type={'number'}
            value={value || 0}
            fullWidth
          />
        )
      // no default
    }
  }

  renderValue = (item, i) => {
    const { classes, value = [{}], disabled: queryDisabled = false, isList } = this.props
    let { field, operator, disabled: itemDisabled = false } = item
    const { options, groupedOptions } = this.state
    let disabledRemoving = value.length === 1

    // if (i === 0 && isList) itemDisabled = true

    const optionsLoaded = !!options
    let disabled = queryDisabled || itemDisabled || !optionsLoaded

    const fieldOptions = options && options.find(o => o.field === field)

    return (
      <Grid
        container
        spacing={16}
        alignItems={'center'}
        className={classes.condition}
        key={`condition_${i}`}
      >
        <Grid item xs={4}>
          <DropDown
            onChange={this.handleFieldChange(i)}
            disabled={disabled}
            value={field}
            options={groupedOptions}
          />
        </Grid>

        <Grid item xs={2}>
          {(!optionsLoaded || (fieldOptions && fieldOptions.operators)) && (
            <DropDown
              onChange={this.handleOperatorChange(i)}
              disabled={disabled}
              value={operator}
              options={fieldOptions && fieldOptions.operators}
            />
          )}
        </Grid>

        <Grid container item xs={6} direction="row">
          <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
            {optionsLoaded &&
              fieldOptions &&
              this.renderValueInput(item, fieldOptions, i, disabled)}
          </div>

          <IconButton
            onClick={this.handleRemoveCondition(i)}
            disabled={disabled || disabledRemoving}
          >
            <Icon>delete</Icon>
          </IconButton>
        </Grid>
      </Grid>
    )
  }

  render() {
    return (
      <ConditionsBlocks
        {...this.props}
        renderValue={this.renderValue}
        NestedComponent={SegmentationQuery}
      />
    )
  }
}

export default withApi(withStyles(styles)(SegmentationQuery))
